module.exports = __webpack_public_path__ + "img/pic_businesscard.df06b861.png";